import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function SEO({ 
  title,
  description,
  image,
  type = 'website',
  author = 'Michaël Cadoul'
}) {
  const location = useLocation();
  const baseUrl = 'https://michael.cadoul.fr';
  const currentUrl = `${baseUrl}${location.pathname}`;
  
  // Default values
  const defaultTitle = 'Michaël Cadoul - Functional Implementation Consultant';
  const defaultDescription = 'Functional Implementation Consultant based in Paris, specialized in NeoXam\'s DataHub solution. Expert in data management for financial markets.';
  const defaultImage = `${baseUrl}/og-image.png`;

  const seoTitle = title || defaultTitle;
  const seoDescription = description || defaultDescription;
  const seoImage = image ? `${baseUrl}${image}` : defaultImage;

  useEffect(() => {
    // Update document title
    document.title = seoTitle;

    // Update or create meta tags
    const updateMetaTag = (name, content, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    };

    // Standard meta tags
    updateMetaTag('description', seoDescription);
    updateMetaTag('author', author);
    updateMetaTag('keywords', 'Consultant, DataHub, NeoXam, Financial Markets, Paris, Developer, Full Stack, React, Node.js, Java, Python');

    // Open Graph tags
    updateMetaTag('og:title', seoTitle, true);
    updateMetaTag('og:description', seoDescription, true);
    updateMetaTag('og:image', seoImage, true);
    updateMetaTag('og:url', currentUrl, true);
    updateMetaTag('og:type', type, true);
    updateMetaTag('og:site_name', 'Michaël Cadoul Portfolio', true);
    updateMetaTag('og:locale', 'en_US', true);

    // Twitter Card tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', seoTitle);
    updateMetaTag('twitter:description', seoDescription);
    updateMetaTag('twitter:image', seoImage);
    updateMetaTag('twitter:creator', '@michael_cadoul');

    // Additional meta tags
    updateMetaTag('robots', 'index, follow');
    updateMetaTag('googlebot', 'index, follow');
    
  }, [seoTitle, seoDescription, seoImage, currentUrl, type, author]);

  return null; // This component doesn't render anything
}

export default SEO;

